<template>
  <div class="requirements-edit">
    <div id="vacancy-requirements-age"
         class="requirements-edit__group"
         :class="inputs.age_not_important.value ? '_disabled' : null">
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.age" :alt="$tNewVacancy('Age')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-head">
          <h3 class="requirements-edit__group-title">{{$tNewVacancy('Age')}}</h3>
          <BaseCheckbox :label="$tNewVacancy('Not important')"
                        :checked="inputs.age_not_important.value"
                        @input="onToggleAge"
                        class="requirements-edit__group-head-checkbox"/>
        </div>

        <div class="requirements-edit__group-row">
          <SliderRange
            :value="[inputs.age_from.value || ageRangeMin, inputs.age_to.value || ageRangeMax]"
            :min="ageRangeMin"
            :max="ageRangeMax"
            :interval="1"
            @input="onAgeInput"
            class="requirements-edit__group-item"
          />
        </div>
      </div>
    </div>
    <div id="vacancy-requirements-experience"
         class="requirements-edit__group"
         :class="inputs.exp_not_important.value ? '_disabled' : null">
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.experience" :alt="$tNewVacancy('Experience')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-head">
          <h3 class="requirements-edit__group-title">{{$tNewVacancy('Experience')}}</h3>
          <BaseCheckbox :label="$tNewVacancy('Not important')"
                        :checked="inputs.exp_not_important.value"
                        @input="onToggleExp"
                        class="requirements-edit__group-head-checkbox"/>
        </div>
        <div class="requirements-edit__group-row">
          <SliderRange :value="[inputs.exp_from.value || expRangeMin]"
                       :min="expRangeMin"
                       :max="expRangeMax"
                       :interval="1"
                       :fromName="$tNewVacancy('from')"
                       @input="onExpInput"
                       class="requirements-edit__group-item"/>
          <button @click.prevent="onPlusExpRangeMax"
                  class="requirements-edit__plus-to-range  _exp  reset-button">+10</button>
        </div>
      </div>
    </div>
    <div id="vacancy-requirements-certificates"
         class="requirements-edit__group">
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.certificate" :alt="$tNewVacancy('Certificates')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-row">
          <TranslateFiled :title="$tNewVacancy('Certificates')"
                          :value="inputs.certificates.value"
                          editor
                          @input="onInput('certificates', $event)"
                          class="requirements-edit__group-item"
          />
        </div>
<!--        <button @click.prevent="addCertificate"-->
<!--                class="base-btn  base-btn&#45;&#45;outline-grey  base-btn&#45;&#45;small">-->
<!--          <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>-->
<!--          <span>Добавить сертификат</span>-->
<!--        </button>-->
      </div>
    </div>
    <div id="vacancy-requirements-language"
         class="requirements-edit__group">
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.language" :alt="$tNewVacancy('Knowledge of the language')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-head">
          <h3 class="requirements-edit__group-title">{{$tNewVacancy('Knowledge of the language')}}</h3>
        </div>
        <div class="requirements-edit__group-row">
          <BaseSelect :value="inputs.language_know.value"
                      text-key="name"
                      :options="languagesList"
                      cancelable
                      @input="onInput('language_know', $event)"
                      class="requirements-edit__group-item"
          />
        </div>

        <div class="requirements-edit__group-row">
          <button v-if="!isShowCommentLangComputed"
                  @click.prevent="onAddCommentLang"
                  class="base-btn  base-btn--outline-grey base-btn--small">
            <BaseSvg name="ico-comment"
                     width="1.3rem"
                     height="1.4rem"
                     style="position: relative; top: 0.1rem"/>
            <span>{{$tNewVacancy('Add a comment')}}</span>
          </button>
          <TranslateFiled v-else
                          :value="inputs.language_know_comment.value"
                          :label="$tNewVacancy('Comment')"
                          textarea
                          rows="5"
                          withFullDelete
                          @input="onInput('language_know_comment', $event)"
                          @delete="onDeleteCommentLang('language_know_comment')"
                          class="requirements-edit__group-item"/>
        </div>

      </div>
    </div>
    <div id="vacancy-requirements-physical"
         :class="inputs.phform_not_important.value ? '_disabled' : null"
         class="requirements-edit__group" >
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.physicalForm" :alt="$tNewVacancy('Physical form')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-head">
          <h3 class="requirements-edit__group-title">{{$tNewVacancy('Physical form')}}</h3>
          <BaseCheckbox :label="$tNewVacancy('Not important')"
                        :checked="inputs.phform_not_important.value"
                        @input="onTogglePHForm"
                        class="requirements-edit__group-head-checkbox"/>
        </div>
        <div class="requirements-edit__group-row">
          <div class="requirements-edit__group-col">
            <SliderRange :label="$tNewVacancy('Weight')"
                         :value="[inputs.phform_weight.value || PHWeightMin]"
                         :min="PHWeightMin"
                         :max="PHWeightMax"
                         :interval="1"
                         @input="onWeightInput"
                         class="requirements-edit__group-item"
            />
          </div>
          <div class="requirements-edit__group-col">
            <SliderRange :label="$tNewVacancy('Height')"
                         :value="[inputs.phform_height.value || PHHeightMin]"
                         :min="PHHeightMin"
                         :max="PHHeightMax"
                         :interval="1"
                         @input="onHeightInput"
                         class="requirements-edit__group-item"
            />
          </div>
        </div>
        <div class="requirements-edit__group-row">
          <BaseCheckbox :label="$tNewVacancy('Disability Allowed')"
                        :checked="inputs.phform_disability_allowed.value"
                        @input="onInput('phform_disability_allowed', $event)"
          />
        </div>
      </div>
    </div>
    <div class="requirements-edit__group">
      <div class="requirements-edit__group-ico-wrap">
        <img :src="icons.additional" :alt="$tNewVacancy('Additional requirements')">
      </div>
      <div class="requirements-edit__group-content">
        <div class="requirements-edit__group-head">
          <h3 class="requirements-edit__group-title">{{$tNewVacancy('Additional requirements')}}</h3>
        </div>
        <div class="requirements-edit__group-row">
          <button v-if="!isShowAdditionalComputed"
                  @click.prevent="onAddAdditional"
                  class="base-btn  base-btn--outline-grey base-btn--small">
            <BaseSvg name="ico-comment"
                     width="1.3rem"
                     height="1.4rem"
                     style="position: relative; top: 0.1rem"/>
            <span>{{$tNewVacancy('Add a description')}}</span>
          </button>
          <TranslateFiled v-else
                          :value="inputs.additional_requirements.value"
                          :label="$tNewVacancy('Description')"
                          textarea
                          rows="5"
                          withFullDelete
                          @input="onInput('additional_requirements', $event)"
                          @delete="onDeleteAdditional('additional_requirements')"
                          class="requirements-edit__group-item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import age from "../assets/img/svg/person-id.svg";
  import experience from "../assets/img/svg/gears.svg";
  import certificate from "../assets/img/svg/certificate.svg";
  import language from "../assets/img/svg/language.svg";
  import physicalForm from "../assets/img/svg/power.svg";
  import additional from "../assets/img/svg/plus.svg";

  import {mapState} from 'vuex'
  import SliderRange from './SliderRange'
  import TranslateFiled from './TranslateFiled'

  export default {
    name: "RequirementsEdit",
    components: {
      SliderRange,
      TranslateFiled
    },
    data() {
      return {
        icons: {
          age,
          experience,
          certificate,
          language,
          physicalForm,
          additional
        },
        isShowCommentLang: false,
        ageRangeMin: 16,
        ageRangeMax: 100,
        expRangeMin: 0,
        expRangeMax: 10,
        PHWeightMin: 45,
        PHWeightMax: 150,
        PHHeightMin: 140,
        PHHeightMax: 220,
        isShowAdditional: false,
      }
    },
    computed: {
      ...mapState('vacancyEdit/requirements/', [
        'muted',
        'languagesList',
        'inputs'
      ]),
      isShowCommentLangComputed() {
        return this.isShowCommentLang || this.inputs.language_know_comment.value
      },
      isShowAdditionalComputed() {
        return this.isShowAdditional || this.inputs.additional_requirements.value
      }
    },
    methods: {
      onInput(key, value) {
        this.$store.commit('vacancyEdit/requirements/setInputValue', {key, value})
      },
      onToggleExp(value) {
        this.onInput('exp_not_important', value)

        if(value) {
          this.onInput('exp_from', null)
        }
      },
      onExpInput(value) {
        this.onInput('exp_from', value[0])
      },
      onToggleAge(value) {
        this.onInput('age_not_important', value)

        if(value) {
          this.onInput('age_from', null)
          this.onInput('age_to', null)
        }
      },
      onAgeInput(value) {
        this.onInput('age_from', value[0])
        this.onInput('age_to', value[1])
      },
      // addCertificate() {
      //   let newValue = this.inputs.certificates.value ? JSON.parse(this.inputs.certificates.value) : '[{}]'
      //   if (!Array.isArray(newValue)) {
      //     newValue = [{}]
      //   }
      //
      //   newValue.push({})
      //
      //   this.onInput('certificates', JSON.stringify(newValue))
      // },
      onAddCommentLang() {
        this.isShowCommentLang = true
      },
      onDeleteCommentLang(key) {
        this.isShowCommentLang = false
        this.onInput(key, null)
      },
      onTogglePHForm(value) {
        this.onInput('phform_not_important', value)

        if(value) {
          this.onInput('phform_weight', null)
          this.onInput('phform_height', null)
          this.onInput('phform_disability_allowed', null)
        }
      },
      onWeightInput(value) {
        this.onInput('phform_weight', value[0])
      },
      onHeightInput(value) {
        this.onInput('phform_height', value[0])
      },
      onAddAdditional() {
        this.isShowAdditional = true
      },
      onDeleteAdditional(key) {
        this.isShowAdditional = false
        this.onInput(key, null)
      },
      onPlusExpRangeMax() {
        this.expRangeMax += 10
        this.onExpInput([(this.inputs.exp_from.value || 0) + 10])
      }
    },
    created() {
      this.$store.dispatch('vacancyEdit/requirements/load')
    }
  }
</script>

<style>

</style>
